import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Page from "../Page/Page";
import SidebarStaff from "../Sidebar/SidebarStaff";
import SidebarAdmin from "../Sidebar/SidebarAdmin";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignIn from "../../Admin/SignIn/SignIn";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../redux/slices/userSlice";
import Questionnaire from "../../Staff/Questionnaire/Questionnaire";
import HealthDeclaration from "../../Staff/HealthDeclaration";
import ForgetPassword from "../../Admin/ForgetPassword/ForgetPassword";
import ResetPassword from "../../Admin/ForgetPassword/ResetPassword";
import VerifyOTP from "../../Admin/ForgetPassword/VerifyOTP";

function MainLayout() {
	const [sidebar, setSidebar] = useState(true);
	const [activePage, setActivePage] = useState("/");
	const [isLogin, setIsLogin] = useState(false);

	const dispatch = useDispatch();
	const userData = useSelector((state) => state.userData.value);

	useEffect(() => {
		let token = localStorage.getItem("token");
		if (token) {
			setIsLogin(true);
		}
	}, [userData]);

	useEffect(() => {
		setActivePage(window.location.pathname);
	}, [window.location.pathname]);

	return (
		<Router>
			<ToastContainer autoClose={5000} />

			{!isLogin ? (
				<Routes>
					<Route path="*" element={<SignIn />} />
					<Route path="/" exact element={<SignIn />} />
					<Route
						path="/questions/:id"
						exact
						element={<Questionnaire />}
					/>
					<Route
						path="/medicalform/:id"
						exact
						element={<HealthDeclaration />}
					/>
					<Route
						path="/forget-password"
						element={<ForgetPassword />}
					/>
					<Route path="/verify-otp" element={<VerifyOTP />} />
					{/* <Route path='/reset-password' element={<ResetPassword />} /> */}
				</Routes>
			) : (!window.location.pathname.includes("/questions") && !window.location.pathname.includes("/medicalform")) ? (
				<div>
					<div className="topHead">
						<div className="container-fluid">
							<div className="topSection">
								<div className="logo-toggle" id="toggler">
									<img
										src="/imgs/logo.svg"
										className="dpImg"
										alt=""
									/>
									<i
										className={`fa-solid fa-bars ${
											sidebar ? "openSidebar" : ""
										}`}
										onClick={() => setSidebar(!sidebar)}
									></i>
								</div>
								<div className="userProfile">
									<i className="fa fa-bell"></i>
									<span className="line"></span>
									<div className="name">
										<h5>{userData?.username}</h5>
										<p>
											Logged as{" "}
											{userData?.isAdmin === true
												? "Admin"
												: "Staff"}
										</p>
									</div>
									<div className="userImg">
										<img
											src="/imgs/userImg.png"
											alt="UserImg"
										/>
									</div>
									<Dropdown>
										<Dropdown.Toggle
											variant="light"
											id="dropdown-basic"
										></Dropdown.Toggle>

										<Dropdown.Menu>
											{/* {userData?.role?.includes("admin") &&
                        userData?.role?.includes("staff") && (
                          <Dropdown.Item>Switch Role</Dropdown.Item>
                        )} */}
											<Dropdown.Item
												onClick={() => {
													localStorage.removeItem(
														"token",
													);
													localStorage.removeItem(
														"orgid",
													);
													localStorage.removeItem(
														"bucketList",
													);
													dispatch(login(null));
												}}
												href={"/"}
											>
												Log Out
											</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
								</div>
							</div>
						</div>
					</div>

					{userData?.isAdmin === true ? (
						<SidebarAdmin
							sidebar={sidebar}
							setSidebar={setSidebar}
						/>
					) : (
						<SidebarStaff
							sidebar={sidebar}
							setSidebar={setSidebar}
						/>
					)}
					<Page sidebar={sidebar} />
				</div>
			) : (
				<Routes>
					<Route
						path="/questions/:id"
						exact
						element={<Questionnaire />}
					/>
					<Route
						path="/medicalform/:id"
						exact
						element={<HealthDeclaration />}
					/>
				</Routes>
			)}
		</Router>
	);
}

export default MainLayout;
